module.exports = __webpack_public_path__ + "static/media/empty.22c6a55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/Empty/img/empty.png
// module id = 1650
// module chunks = 0